// IdleLogout.jsx
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../auth/authSlice"; // adjust path
import { toast } from "react-toastify";

export default function IdleLogout({ minutes = 15 }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((s) => s.auth.login.userid);
  const timerRef = useRef(null);
localStorage.setItem("userToken",'');
  const logoutNow = useCallback(() => {
    dispatch(logout());
    toast.info("Logged out due to inactivity.");
    navigate("/login", { replace: true });
  }, [dispatch, navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logoutNow, minutes * 60 * 1000);
  }, [logoutNow, minutes]);

  useEffect(() => {
    // only track if logged in
    if (!token) {
      if (timerRef.current) clearTimeout(timerRef.current);
      return;
    }

    resetTimer();

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, resetTimer));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [token, resetTimer]);

  return null;
}
